// extracted by mini-css-extract-plugin
export default {"popper":"popper§LvWXpdpdZGPRz0UoRJLa","body":"body§eC205Mx59u50ajYaNjAb","comments":"comments§qlmsTKeauzmwodpflgpB","hint":"hint§kq2bSqW2Cswce5sgBKnf"};